import React from 'react'
import { StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Icon, Text } from '@components'
import { useLanguage } from '@context'
import { Theme } from '@theme'

interface OfflineBannerProps {
  isOnline: boolean
  pendingCount: number
}

/**
 * "Hors ligne — N pointages en attente": shown on the entrance screens
 * whenever scans are queued locally, whether the network is actually down
 * right now or a sync is simply still catching up.
 */
export function OfflineBanner({ isOnline, pendingCount }: OfflineBannerProps) {
  const theme = useTheme()
  const { t } = useLanguage()
  const styles = getStyles(theme)
  if (pendingCount === 0) return null

  return (
    <View style={styles.banner} testID="offline-banner">
      <Icon name="alertTriangle" size={18} color={theme.colors.orange} />
      <Text type="bodySmallBold" color={theme.colors.orange} style={styles.text}>
        {isOnline
          ? t('events.checkin.offline.syncing', { count: pendingCount })
          : t('events.checkin.offline.banner', { count: pendingCount })}
      </Text>
    </View>
  )
}

const getStyles = (theme: Theme) =>
  StyleSheet.create({
    banner: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing.sm,
      paddingHorizontal: theme.spacing.md,
      paddingVertical: theme.spacing.sm,
      borderRadius: theme.border.medium,
      backgroundColor: theme.colors.sidebar,
      marginBottom: theme.spacing.sm,
    },
    text: { flexShrink: 1 },
  })
